import React from 'react';
import './style.css';
import MainNav from './MainNav';

const UnderConstruction = () => {
    return (
      <div className="under-construction"> 
      <MainNav />
      <h1>This page is under construction</h1>
      </div>
      
    );
  };
  
  export default UnderConstruction;